export default __webpack_public_path__ + "static/media/fav-list-white.53f23bef.svg";